import { GetData } from "../Api";
import { useEffect, useState, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import totalOutputQuantity from "../Assets/Images/total_output.svg";
import defectPercentage from "../Assets/Images/defectPercentage.svg";
import averageDefectCount from "../Assets/Images/averagedefectcount.svg";
import downTime from "../Assets/Images/downtime.svg";
import defectsCount from "../Assets/Images/Defect_count.svg";
import { useParams } from 'react-router-dom';
import PrinterImg from "../Assets/Images/inspection.png";
import BarChart from "../Components/BarChart";
import FilterContext from "../Hooks/Context";
import { Doughnut, Bar } from "react-chartjs-2";
import { FunnelChart } from "react-funnel-pipeline";
import "react-funnel-pipeline/dist/index.css";
import { lineScrapDPMChartOptions, scrapRateFirstPassOptions, topTrueDefectsOptions } from "../Hooks/Common";
import Filter from "../Components/Filter";
import Download from "./Download";
import {factoryStartEndTime} from '../Hooks/Common'
import Dropdown from "../Components/dropdown";
import CustomDonutChart from "../Components/DonutChart/CustomDonutChart";

const ValidateColor = (processValue) => {
  let status;
  if (processValue >= 90) {
    // Green
    status = "#3cc480";
  } else if (processValue > 60 && processValue < 90) {
    // Yellow
    status = "#ffc60a";
  } else if (processValue <= 60) {
    // Red
    status = "#ff5544";
  }

  return status;
};

const PreAoi = () => {
  const [menuStatus, SetMenuStatus] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [heading, Setheading] = useState("");
  const [spiData, SetSPIData] = useState();
  const [widgetsData, SetWidgetsData] = useState();
  const [measuresData, SetMeasuresData] = useState();
  const { t } = useTranslation();
  const [componentscount, SetComponentscount] = useState();
  const [errorResponse, SetErrorResponse] = useState(false);
  const [noDataAvailable, SetNoDataAvailable] = useState(false);
  let { slug } = useParams();
  const [ slugValue, SetSlugValue] = useState(slug); 
  const [qualityText, SetQualityText] = useState();
  const [modelFilter, SetModelFilter] = useState([
    { id: "1", label: "All Product" },
    { id: "2", label: "Current Product" },
  ]);
  const [converyorFilter, SetConveryorFilter] = useState([
    { id: 1, label: "All Conveyors" },
    { id: 2, label: "Conveyor 1" },
    { id: 3, label: "Conveyor 2" }
  ]);
  const [modelFilterId, SetModelFilterId] = useState(1);
  const [conveyorFilterId, SetConveyorFilterId] = useState(1);
  const [defectReferenceData, SetDefectReferenceData] = useState();
  const SetFilterValue = (id) => {
    SetModelFilterId(id)
  };

  const SetConveyorFilterValue = (id, name) => {
    
    let index = parseInt(id) - 2;
    SetConveyorFilterId(id);
    if(id === "1"){
      SetDefectReferenceData(spiData.statistics.defect_reference.data);
    } else {
      SetDefectReferenceData(spiData.statistics.defect_reference.filtered_data[(parseInt(id) - 2)].data);
    }

  };

  const [time, setTime] = useState(0);
  const [liveStatus, SetLiveStatus] = useState(true);
  const timer = useRef();

  const filterQueries = useContext(FilterContext);

  const history = useHistory();

  const slugConfig = {
    'inspection': {
      'ApiName' : 'spi',
      'Heading' : 'MACHINE DASHBOARD – SPI'
    },
    'preaoi': {
      'ApiName' : 'pre-aoi',
      'Heading' : 'MACHINE DASHBOARD – Pre-AOI'
    },
    'postaoi': {
      'ApiName' : 'spi',
      'Heading' : 'MACHINE DASHBOARD – Post-AOI'
    }
  }

  const ToggleClass = () => {
    SetMenuStatus(!menuStatus);
  };

const GetSPIData = () => {
    
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `dashboard/pre-aoi?&startTs=${filterQueries.filterRequestQuery.startTs}&endTs=${filterQueries.filterRequestQuery.endTs}&shift=${filterQueries.filterRequestQuery.shift}`
      )
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          if (data.measures.length !== 0 && data.statistics.length !== 0) {
            SetFilterValue('1')
            SetSPIData(null);
            SetSPIData(data);
            let widgetData = {};
            SetWidgetsData(widgetData);
            SetMeasuresData(data.measures);
            SetNoDataAvailable(false);
            SetErrorResponse(false)
          } else {
            SetSPIData(null);
            SetWidgetsData(null);
            SetMeasuresData(null);
            SetNoDataAvailable(true);
            SetErrorResponse(true)
          }
        })
        .catch((error) => {
          SetSPIData(null);
          SetWidgetsData(null);
          SetMeasuresData(null);
          SetNoDataAvailable(true);
          SetErrorResponse(true);
        });
    }
  };

  const GenerateStatisticsData = (data) => {
    return (
      <div className="line-overview-wrapper  inspection-line-wrapper">
        {data &&
          data.map((item, index) => {
            let processValue = parseInt(item.value);
            let statusColor = ValidateColor(processValue);

            return (
              <div key={item.name} className="inspection-line-wrapper-item">
                <div className="row">
                  <div className="col-3 line-item-image">
                    <img src={lineImages[item.name]} alt={item.name} />
                  </div>
                  <div className="col-8 factory-overview-item-right">
                    <div className="line-overview-wrapper-item item-name">
                    { item.name === "DPMO" ? parseInt(item.value) : item.value }
                    </div>
                    <div className="line-overview-wrapper-sublabel item-label">
                      {t(item.name)}
                    </div>
                    <div className="line-overview-wrapper-range-sublabel">
                    {item.target === "" ? "N/A" : item.target}
                    {item.unit === 'sec'? ' '+item.unit : (item.unit !== 'number' ? item.unit : '')}
                      <br />
                      <div className="line-overview-wrapper-sublabel no-border item-label">
                        {t("LT_target_number")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const GeneratePrinterData = (data) => {
    return (
      <div className="Printer-overview printer-container inspection-wrapper">
        <div className="row">
          <div className="col-12 printer-overview-header">
            {data.statistics.name}
          </div>
        </div>
        <div className="row">
          {data.conveyors &&
            data.conveyors.map((conveyor, index) => {
              return (
                <div key={`conveyor1${index}`} className="col-md-5 col-sm-12">
                  <div className="row">
                  <div className="col-12 printer-overview-heading" style={{'paddingLeft': '12px', 'paddingBottom' : '15px' }}>
                        {t("LT_smt_line_02_pre_aoi_latest_wip")}
                      </div>
                    <div className="col-12">
                      <div className="conveyor-title">{t("LT_conveyor")} {index + 1}</div>
                        <div className="field-container">
                          <div className="field-container-left">{t("LT_timeStamp")}</div>
                          <div className="field-container-right">
                            {conveyor.date === "" ? "N/A" : conveyor.date}
                          </div>
                        </div>
                        <div className="field-container">
                          <div className="field-container-left">{t("LT_barcode")}</div>
                          <div className="field-container-right">
                            {conveyor.pcb_number}
                          </div>
                        </div>
                        <div className="field-container">
                          <div className="field-container-left">{t("LT_product_name")}</div>
                          <div className="field-container-right">
                            {conveyor.model_number}
                          </div>
                        </div>
                        <div className="field-container">
                          <div className="field-container-left">
                            {t("LT_inspection")} {t("Id")}
                          </div>
                          <div className="field-container-right">
                            {conveyor.inspection_id}
                          </div>
                        </div>
                        <div className="field-container nil-border-bottom">
                          <div className="field-container-left">{t("LT_result")}</div>
                          <div className="field-container-right">
                            {conveyor.result}
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              );
            })}
          <div className="col-2" style={{ textAlign: "center" }}>
            <img src={PrinterImg} alt="Printer" width="80" />
          </div>
        </div>
      </div>
    );
  };

  const machineDashboard = ["scrap_rate", "first_pass", "scrap_ppm"];

  const GetColor = (conveyor, value) => {
    if (conveyor === "first_pass") {
      if (value < 0) {
        return "#FF4141";
      } else {
        return "#3CC480";
      }
    } else {
      if (value > 0) {
        return "#FF4141";
      } else {
        return "#3CC480";
      }
    }
  };

  const GenerateMachineDashboard = (data) => {
    return (
      <div className="Printer-overview">
        <div className="row machine-wrapper">
          {machineDashboard &&
            machineDashboard.map((conveyor, index) => {
              if (!data.statistics[conveyor]) return false;
              let labelColor = GetColor(
                conveyor,
                parseFloat(data.statistics[conveyor].trend)
              );
              return (
                <div key={`machinedashboard${index}`} className="machine-dashboard-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="conveyor-title factory-overview-header">
                       {t(data.statistics[conveyor].name)}
                      </div>
                      <div className="row">
                        <div className="col-4 machine-title-wrapper">
                          <span className="machine-title trend-label">
                            {data.statistics[conveyor].average.toFixed(2)}{" "}
                            {conveyor === "scrap_ppm" ? "" : "%"}
                          </span>
                          <br />
                          <span
                            className="machine-title trend-title"
                            style={{ color: labelColor }}
                          >
                            {labelColor === "#FF4141" ? (
                              <i
                                className={`fa fa-arrow-down`}
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className={`fa fa-arrow-up`}
                                aria-hidden="true"
                              ></i>
                            )}
                            &nbsp;
                            {data.statistics[conveyor].trend}
                          </span>
                        </div>
                        <div className="col-8 charts-inspection">
                          <BarChart
                            barchartData={data.statistics[conveyor].data}
                            isGeneric={false}
                            options={(conveyor === "scrap_ppm") ? lineScrapDPMChartOptions : (conveyor === "scrap_rate" || conveyor === "first_pass") ? scrapRateFirstPassOptions : scrapRateFirstPassOptions }
                          />
                          <div className='trendText'>{ t("LT_60_days_trend")}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  const lineImages = {
    "LT_total_output_quantity": totalOutputQuantity,
    "LT_true_defect_percentage": defectPercentage,
    'LT_dpmo': averageDefectCount,
    "LT_false_defect_percentage": defectsCount,
    'LT_dpu': downTime,
  };

  useEffect(() => {
    //GetSPIData();
    SetLiveStatus(true);
  }, []);

  /* Live Module Starts from Here */

  const [pauseLive, SetPauseLive] = useState(false);
  const [timeInterval, setTimeInterval] = useState(0);
  var timeout, timeIntervalCount;

  const EnableLiveData = (event) => {
    SetPauseLive(false);

    let fset = factoryStartEndTime()
        let startDate = fset.startTs
        let endDate = fset.endTs
  
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.isLive = true;
    filterRequestQuery.startTs = startDate;
    filterRequestQuery.endTs = endDate;
    filterQueries.GenerateFilters(filterRequestQuery);
  }

  useEffect(() => {
    if(!pauseLive) {
      timeout = setTimeout(() => {
        timeIntervalCount = setTimeInterval(timeInterval + 1);
        }, 60000);
    }
  });

  useEffect(() => {
    GetSPIData();
  },[ filterQueries ]);

  useEffect(() => {
    if(filterQueries.filterRequestQuery.isLive) {
      SetPauseLive(false);
    } else {
      SetPauseLive(true);
    }
  },[ filterQueries.filterRequestQuery ]);

  useEffect(() => {
    let myDate = new Date( filterQueries.filterRequestQuery.startTs *1000);
    let gmtString = myDate.toGMTString();
    if(filterQueries.filterRequestQuery.isLive) {
      let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
      filterRequestQuery.isLive = true;
      filterQueries.GenerateFilters(filterRequestQuery);
    } else {
      let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
      filterRequestQuery.isLive = false;
      filterQueries.GenerateFilters(filterRequestQuery);
      clearTimeout(timeout);
      clearInterval(timeIntervalCount);
    }
    
  }, [timeInterval]);

  /* Live Module Ends from Here */

  const options = {
    legend: {
      position: "bottom",
      align: "left",
    },
  };

  const GenerateComponentsCountChart = () => {
    if (!spiData) return false;
    return (
      <div className='ComponentsCounts' id='ComponentsCounts'>
        <FunnelChart
          data={spiData.statistics.component_count.data}
          getToolTip={(row) => { return row.name + ': ' + row.value}}
          Id='ComponentsCountsChart'
          asc={false}
          pallette={[
            "#3CC480",
            "#82CEDF",
            "#3B86FF",
            "#FFD447",
            "#43425D",
            "#5F34F5",
          ]}
        />
      </div>
    );
  };


  const GenerateInspectionDashboard = (spiData) => {
    if (!spiData) return false;
    let dounutChartData = {
      labels: ["Pass", "Fail"],
      datasets: [
        {
          label: spiData.statistics.quality.name,
          data: [
            parseFloat(spiData.statistics.quality.good_percent),
            parseFloat(spiData.statistics.quality.scrap_percent)
          ],
          backgroundColor: ["rgb(60,196,128)", "#3B86FF"],
          borderWidth: 0,
        },
      ],
    };

    if (!spiData.statistics.top_quality) return false;
    let defectLables = [],
      defectData = [];
    spiData &&
      spiData?.statistics?.top_quality?.data.map((defect, index) => {
        defectLables.push(defect.name);
        defectData.push(parseFloat(defect.value.toFixed(2)));
      });

    let dounutDefectChartData = {
      labels: defectLables,
      datasets: [
        {
          label: spiData.statistics.top_quality.name,
          data: defectData,
          backgroundColor: [
            "#FFD447",
            "#FF5543",
            "#5F34F5",
            "#3587B8",
            "#82CEDF",
            "#3CC480",
            "#585858",
            "#82CEDF",
          ],
          borderWidth: 0,
        },
      ],
    };

    const options = {
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
    };

    let defectComponentCountDataset = [],
      defectComponentCountDatasetColor = [
        "#FFD447",
        "#FF5543",
        "#5F34F5",
        "#3587B8",
        "#82CEDF",
        "#3CC480",
        "#585858",
        "#82CEDF",
      ];

    let defectCountLables = [];
    let defecCountDatset = [];
    spiData &&
      spiData.statistics.defect_count.data.map((defect, index) => {
        defectCountLables.push(defect.name);
        defect.filter_data && defect.filter_data.map((individualDefect, innerIndex) => {
          let defectObj = {
            label: individualDefect.name,
            backgroundColor: defectComponentCountDatasetColor[innerIndex],
            barThickness: 40,
            categoryPercentage: 1,
            pointStyle: "triangle",
            stack: 1,
            data: []
          };
          for(let i=0; i< index; i++) {
            defectObj.data.push('0');
          }
          defectObj.data.push(individualDefect.value);
          defecCountDatset.push(defectObj)
        });
    });

    const plugins = [{
      beforeDraw: function(chart) {
       var width = chart.width,
           height = chart.height,
           ctx = chart.ctx;
           ctx.restore();
           var fontSize = (height / 170).toFixed(2);
           ctx.font = fontSize + "em sans-serif";
           ctx.textBaseline = "top";
           var text = dounutChartData.datasets[0].data[0] + '%',
           textX = Math.round((width - ctx.measureText(text).width) / 2),
           textY = height / 2.5;
           ctx.fillText(text, textX, textY);
           ctx.save();
      } 
    }]

    return (
      <div className="inspection-dashboard-container">
        <div className="inspection-card">
          <div className="inspection-dashboard-title">
            {spiData && t(spiData.statistics.quality.name)}
          </div>
          <div className="inspection-card-content Quality">
          {/* <Download chartid={ 'Quality' }  chartData={ dounutChartData }/> */}
          <CustomDonutChart series= {dounutChartData.datasets[0].data} labels={dounutChartData.labels} legendPosition="bottom" title={dounutChartData.datasets[0].data[0]+"%"} width="230" />
            {/* <Doughnut
              data={dounutChartData}
              plugins={ plugins }
              options={{
                cutout: '70%',
                display: 'auto',
                pieHole: 0.1,
                plugins: {
                  legend: {
                    position: "bottom",
                    align: "start"
                  },
                  tooltip: {
                    callbacks: {
                      title: function (tooltipItems) {
                        return tooltipItems[0].label;
                      },
                      label: (data) => { 
                        return data.formattedValue + '%';
                      }
                    },
                  },
                },
              }}
            /> */}

          </div>
        </div>
        <div className="inspection-card">
          <div className="inspection-dashboard-title">
            {spiData && t(spiData.statistics.top_quality.name)}
          </div>
          <div className="inspection-card-content topQualityDefects" id="topQualityDefects">
            {/* <Download chartid={ 'topQualityDefects' }  chartData={ dounutDefectChartData }/> */}
            {dounutDefectChartData && 
            <CustomDonutChart series= {dounutDefectChartData.datasets[0].data} labels={dounutDefectChartData.labels} legendPosition="bottom"width="230"/>}
            {/* { dounutDefectChartData && <Doughnut
              data={dounutDefectChartData}
              width="100"
              height="200"
              plugins={[ChartDataLabels]}
              options={{
                cutout: '80%',
                layout: {
                  padding: {
                      left: 5,
                      right: 5,
                      top: 20,
                      bottom: 5
                  }
              },
                plugins: {
                  pieHole: 1,
                  datalabels: {
                    display: 'auto',
                    color: '#333333',
                    formatter: function (value) {
                      return value + '%';
                    },
                    anchor: 'end',
                    align: 'end',
                    offset: function(context){
                      return 5;
                    },
                    font: {
                      size: 12,
                    }
                  },
                  legend: {
                    position: "bottom",
                    align: "start",
                    labels: {
                      padding: 22,
                      usePointStyle: true,
                      render: 'label',
                      fontColor: '#000',
                      position: 'outside',
                      font: {
                        size: 8
                      }
                    }
                  },
                  tooltip: {
                    callbacks: {
                      title: function (tooltipItems) {
                        return tooltipItems[0].label;
                      },
                      label: (data) => { 
                        return data.formattedValue + '%';
                      }
                    },
                  },
                },
              }}
            /> } */}
          </div>
        </div>
        <div className="inspection-card stacked-bar-container">
          <div className="inspection-dashboard-title">
          { t("LT_root_cause_machines") }
          </div>
          <div className="inspection-card-content">
            <div className='inspection-card-content-bar Components'>
            {/* <Download chartid={ 'Components' }  chartData={ defecCountDatset } chartLables = { defectCountLables } /> */}
            <Bar
              height={290}
              plugins={[ChartDataLabels]}
              data={{
                labels: defectCountLables,
                responsive: true,
                offset: true,
                datasets: defecCountDatset
              }}
              options={{
                scales: {
                  x: {
                    display: true,
                    ticks: {
                      display: true,
                    },
                  },
                  y: {
                    display: true,
                    title: {
                      display: true,
                      text: 'Count'
                    },
                    ticks: {
                      display: true
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: 'auto',
                    color: '#ffffff',
                    formatter: function (value) {
                      return value;
                    },
                    anchor: 'center',
                    align: 'center',
                    offset: function(context){
                      return 5;
                    },
                    font: {
                      size: 12,
                    }
                  },
                  legend: { 
                    display: true,
                    position: "bottom",
                    align: "start"
                  },
                },
                offsetGridLines: true,
                drawTicks: true,
                layout: {
                  padding: {
                    top: 30,
                    right: 40,
                    bottom: 40
                  }
                },
                legend: {
                  display: false,
                  position: "right",
                  align: "start"
                },
                responsive: true,
                maintainAspectRatio: true
              }}
            />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const GenerateJobStatus = (data, index) => {
    if(!data) return false;
    let dounutChartData = {
      labels: ["Machine Good", "False Call", "Failure"],
      datasets: [
        {
          label: data.name,
          data: [
            parseFloat(data.good_qty_percent),
            parseFloat(data.false_call_qty_percent),
            parseFloat(data.failure_qty_percent),
          ],
          backgroundColor: [
            "rgb(60,196,128)",
            "rgb(255,198,10)",
            "rgb(255,85,67)",
          ],
          borderWidth: 0,
        },
      ],
    };

    const plugins = [{
      beforeDraw: function(chart) {
       var width = chart.width,
           height = chart.height,
           ctx = chart.ctx;
           ctx.restore();
           var fontSize = (height / 220).toFixed(2);
           ctx.font = fontSize + "em sans-serif";
           ctx.textBaseline = "top";
           var text = data.ppm;
           var text1 = 'DPM',
           textX = Math.round((width - ctx.measureText(text).width) / 2),
           text1X = Math.round((width - ctx.measureText(text1).width) / 2),
           textY = height / 2.5;
           if(window.screen.width > 1440) {
            textY = height / 2.5;
           } else {
            textY = height / 3.1;
           }
           // ctx.fillText(text1, text1X, textY-15);
           // ctx.fillText(text, textX, textY);
           ctx.save();
      } 
    }]

    return (
      <div key={`printer${index}`} className="Printer-overview printer-container  inspection-container-area ">
        <div className="row">
        <div className="conveyor-title" style={{'paddingLeft':'10px'}}>{t("LT_conveyor")} {index + 1}</div>
        </div>
        <div className="row">
          <div className="col-6 printer-overview-container">
            <div className="row">
            <div className="col-12">
            { modelFilterId === "2" && <div className="field-container">
                  <div className="field-container-left">{t("LT_product_name")}</div>
                  <div className="field-container-right">
                    {data.model_number}
                  </div>
                </div> }
                <div className="field-container">
                  <div className="field-container-left">
                    {t("LT_total_inspected_qty")}
                  </div>
                  <div className="field-container-right">{data.total_qty}</div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_machine_good_qty")}</div>
                  <div className="field-container-right">{data.good_qty}</div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_false_call_qty")}</div>
                  <div className="field-container-right">
                    {data.false_call_qty}
                  </div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_failure_qty")}</div>
                  <div className="field-container-right">
                    {data.failure_qty}
                  </div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_machine_good_qty")}%</div>
                  <div className="field-container-right">
                    {data.good_qty_percent}
                  </div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_false_call_qty")}%</div>
                  <div className="field-container-right">
                    {data.false_call_qty_percent}
                  </div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("LT_failure_qty")}%</div>
                  <div className="field-container-right">
                    {data.failure_qty_percent}
                  </div>
                </div>
                <div className="field-container">
                  <div className="field-container-left">{t("DPM")}</div>
                  <div className="field-container-right">{data.ppm}</div>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-5 donut-chart-container conveyor-chart Conveyor${index + 1}`}>
            <CustomDonutChart series= {dounutChartData.datasets[0].data} labels={dounutChartData.labels} legendPosition="bottom" title="DPM" subtitle={data.ppm} width="230"/>
            
            {/* <div className="doughnut-static-legend">DPM<br />{data.ppm}</div>
            {(parseFloat(data.failure_qty_percent) > 0 || parseFloat(data.good_qty_percent) > 0 || parseFloat(data.false_call_qty_percent) > 0) && 
           
            <Doughnut
              data={dounutChartData}
              plugins={ plugins }
              options={{
                cutout: '70%',
                plugins: {
                  legend: {
                    position: "bottom",
                    align: "start",
                  },
                  tooltip: {
                    callbacks: {
                      title: function (tooltipItems) {
                        return tooltipItems[0].label;
                      },
                      label: (data) => { 
                        return data.formattedValue + '%';
                      }
                    },
                  }
                },
              }}
            />
            } */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <h4>{t("LT_machine_dashboard_pre_aoi")}</h4>
      { !pauseLive && (
        <span className="liveStatus">
          { t("LT_live") }{" "}
          <span
            className={`showLive ${liveStatus ? "live-icon" : "relay"}`}
          ></span>
        </span>
      )}
      { pauseLive && <div className='live-btn' onClick={ (event) => { EnableLiveData(event) } }>{t("LT_enable_live_data")}</div>}
      <Filter showDatePicker={false} />

      <div className="row">
        <div className="col-12">
          <Tabs>
            <TabList>
              <Tab>{t("LT_job_status")}</Tab>
              <Tab>{t("LT_machine_dashboard_circuit")}</Tab>
              <Tab>{t("LT_machine_dashboard_component")}</Tab>
            </TabList>

            <TabPanel>
              {spiData && GeneratePrinterData(spiData)}
              <div className="row">
                <div className="col-md-12 printer-outer-container">
                <div className="col-12 printer-overview-heading">{ spiData &&  t("LT_smt_line_02_pre_aoi_daily_job_status")}</div>
                <div class="col-11 position-relative">
                  <div class="position-absolute top-0 start-100 translate-middle" style={{marginTop: '-25px'}}>
                    <Dropdown
                      data={modelFilter}
                      placeholder={t("All Product")}
                      selectedItem={modelFilter[0]}
                      name="model-filter"
                      noReload={true}
                      SetFilterValue={SetFilterValue}
                    />
                  </div>
                </div>
                  {spiData &&
                    spiData.statistics?.job_status.map((data, index) => {
                      if (modelFilterId === '2') return GenerateJobStatus(data.filtered_data, index);
                      else return GenerateJobStatus(data, index);
                      //return GenerateJobStatus(data, index);
                    })}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              {spiData && GenerateMachineDashboard(spiData)}
              {GenerateInspectionDashboard(spiData)}
            </TabPanel>
            <TabPanel>
              {!noDataAvailable && (
                <>
                  <div className="inspection-wrapper">
                    {spiData && GenerateStatisticsData(spiData.measures)}
                  </div>
                  <div className="inspection-container">
                    <div className="inspection-container-left inspection-wrapper chart-inspection-wrapper">
                      <div className="inspection-heading">
                        {t("LT_top_true_defect_references")}
                      </div>

                      <div className="row">
                        <div className="col-md-12 TopTrueDefectChart">
                        <div className="conveyor-filter" >
                          
                        <Dropdown
                      data={converyorFilter}
                      placeholder={t("All Conveyors")}
                      selectedItem={converyorFilter[0]}
                      name="model-filter"
                      noReload={true}
                      SetFilterValue={SetConveyorFilterValue}
                    />
                    </div>
                    <div key={ conveyorFilterId } >
                        {/* {spiData?.statistics?.defect_reference &&  <Download chartid={ 'TopTrueDefectChart' }  chartData={ spiData.statistics.defect_reference.data }/> } */}
                          {spiData?.statistics?.defect_reference && (
                            <BarChart
                            barchartData={ !defectReferenceData ? spiData.statistics.defect_reference.data :  defectReferenceData}
                              isGeneric={false}
                              showLabels={ true }
                              options={ topTrueDefectsOptions }
                            />
                          )}
  </div>
                        </div>
                      </div>
                    </div>
                    <div className="inspection-container-right  inspection-wrapper funnel-chart-container">
                      <div className="inspection-heading">
                        {t("LT_components_counts")}
                      </div>
                      {GenerateComponentsCountChart()}
                    </div>
                  </div>
                </>
              )}
            </TabPanel>
          </Tabs>
        </div>
        <div style={{"display":"none"}}>
          <canvas id="fabric-canvas" width="500" height="500" />
          </div>
      </div>
    </>
  );
};

export default PreAoi;
